/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  AppSidebar,
  DashboardHeader,
  DashboardBreadcrumb,
  DashboardFooter,
} from "@/components/layout/dashboard-layout";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useEffect, useMemo, useState } from "react";
import { getToken, getUserInfo } from "@/lib/token";
import {
  /* ADMIN_PAGES, */ reDirections /* SHARED_PAGES */,
} from "@/app/redirctions";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { NotAuthorisedTemplate } from "../not-authorised-template";
import { useUserInfo } from "@/global-data/use-user-info";
import { menu } from "@/app/menu";
import { NotAuthorizedTemplateV2 } from "@/components/shared/not-authorized-template-v2";
export const Dashboard = () => {
  const { permission, setActivePermission, configProcess } = useUserInfo();

  const [loading, setLoading] = useState(true);
  const [isPageExist, setIsPageExist] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUserInfo();

  const token = getToken();

  useEffect(() => {
    if (token) {
      setLoading(false);
    } else {
      navigate("/login");
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      setLoading(false);
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (token) {
      reDirections.forEach((reDirection) => {
        if (location.pathname === reDirection.currentUrl) {
          if (user?.username === "system") {
            navigate(reDirection.redirectUrlAdmin);
          } else {
            navigate(reDirection.redirectUrl);
          }
        }
      });
      const currentPage = menu?.navMain?.find((items: any) =>
        location.pathname.startsWith(items.url),
      );
      const currentPermission: any = permission.find(
        (items) => items.name === currentPage?.key,
      );
      setActivePermission(currentPermission);
      if (permission.length === 0) {
        setIsPageExist(false);
      } else if (currentPermission) {
        setIsPageExist(currentPermission?.view === true);
      }
      // console.log("pathname", location.pathname);
      if (["/profile", "/settings"].includes(location.pathname)) {
        setIsPageExist(true);
      }

      // else if (user?.username === "system") {
      //   if (ADMIN_PAGES.includes(location.pathname)) {
      //     setIsPageExist(true);
      //   } else {
      //     setIsPageExist(SHARED_PAGES.includes(location.pathname));
      //   }
      // } else {
      //   setIsPageExist(!ADMIN_PAGES.includes(location.pathname));
      // }
    }
  }, [location, permission]);

  const hasAuth = (key: string) => {
    const currentPagePermission = permission.find(
      (permissionItem) => permissionItem.name === key,
    );
    return currentPagePermission?.view;
  };

  const hasAnyPerision = useMemo(() => {
    const menu_list = menu.navMain.some(
      (item) => item?.hide !== false && hasAuth(item.key),
    );
    return menu_list;
  }, [permission]);

  return (
    <SidebarProvider>
      {loading || configProcess ? (
        <div className="flex items-center justify-center w-full h-[100dvh] ">
          <div className="web-loader"></div>
        </div>
      ) : hasAnyPerision ? (
        <>
          <AppSidebar />
          <SidebarInset className="px-3 py-4">
            <DashboardHeader />
            <div className="flex flex-1 mt-3 flex-col gap-4 p-4 pt-0">
              <DashboardBreadcrumb />
              <ConditionRenderer condition={isPageExist}>
                <Outlet />
                <NotAuthorisedTemplate />
              </ConditionRenderer>
            </div>
            <DashboardFooter />
          </SidebarInset>
        </>
      ) : (
        <NotAuthorizedTemplateV2 />
      )}
    </SidebarProvider>
  );
};
